import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { slugify } from "../../../../util/slugify";

const TableScrollWrapper = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.thead`
  background: #f5f5f5;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background: #f9f9f9;
  }
  &:hover {
    background: #f0f0f0;
  }
`;

const TableHeaderCell = styled.th`
  padding: 12px;
  text-align: left;
  font-weight: bold;
  border-bottom: 2px solid #ddd;

  @media (max-width: 768px) {
    padding: 8px;
  }
`;

const TableCell = styled.td`
  padding: 12px;
  border-bottom: 1px solid #eee;

  @media (max-width: 768px) {
    padding: 8px;
  }
`;

const RestaurantLink = styled(Link)`
  color: #4caf50;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;

const MostClickedRestaurants = ({ data, loading }) => {
  if (loading) {
    return <LoadingMessage>Loading data...</LoadingMessage>;
  }

  if (!data || data.length === 0) {
    return <LoadingMessage>No restaurant click data available.</LoadingMessage>;
  }

  return (
    <TableScrollWrapper>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHeaderCell>Rank</TableHeaderCell>
            <TableHeaderCell>Restaurant Name</TableHeaderCell>
            <TableHeaderCell>Restaurant ID</TableHeaderCell>
            <TableHeaderCell>Clicks</TableHeaderCell>
          </TableRow>
        </TableHeader>
        <tbody>
          {data.map((item, index) => (
            <TableRow key={item.restaurantId}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>
                <RestaurantLink to={item.restaurantName ? `/details/${item.restaurantId}/${slugify(item.restaurantName)}` : `/details/${item.restaurantId}`}>
                  {item.restaurantName || "Unknown Restaurant"}
                </RestaurantLink>
              </TableCell>
              <TableCell>
                <RestaurantLink to={item.restaurantName ? `/details/${item.restaurantId}/${slugify(item.restaurantName)}` : `/details/${item.restaurantId}`}>
                  {item.restaurantId}
                </RestaurantLink>
              </TableCell>
              <TableCell>{item.count.toLocaleString()}</TableCell>
            </TableRow>
          ))}
        </tbody>
      </Table>
    </TableScrollWrapper>
  );
};

export default MostClickedRestaurants;

